// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-pro-header-menu .anticon{margin-right:8px}.ant-pro-header-menu .ant-dropdown-menu-item{min-width:160px}.ant-pro-drop-down{line-height:64px;vertical-align:top;cursor:pointer}.ant-pro-drop-down>i{font-size:16px!important;transform:none!important}.ant-pro-drop-down>i svg{position:relative;top:-1px}", ""]);
// Exports
module.exports = exports;
